import React, { Component } from 'react'
import { connect } from "react-redux";
import { compose } from "redux";
import swal from 'sweetalert';
import { getSchool, getClassName, getLanguageName, getClassId, getLanguageId, getCartProducts } from '../modules/reducers';
import { addProductsToCart } from "../modules/actions";
import Footer from '../components/Footer';
import Header from '../components/Header';
import axios from 'axios';
import { BASEURL } from '../Config';

export class schoolProducts extends Component {
    constructor(props) {
        super(props);
        this.state = {
            lname: '',
            languageProducts: [],
            books: [],
            stationery: [],
            uniform: [],
            clothing: [],
            accessories: [],
            salesPrice: 0,
            productSetName: '',
            productSetId: '',
            measurementModal: {
                show: false,
                productIdx: null,
                loading: false,
                data: null,
                error: null,
            }
        }
    }
    componentDidMount() {
        this.setState({
            productSetName: this.props.school.name +  ' - ' + this.props.className + ' - ' + this.props.lname,
            productSetId: this.props.school._id + '-' + this.props.classId + '-' + this.props.langId
        })
        let input = {};
        input.schoolId = this.props.school._id;
        input.state = this.props.school.state;
        input.stype = this.props.school.type;
        input.classId = this.props.classId;
        input.langId = this.props.langId;
        axios.post(`${BASEURL}/api/v1/languageProducts/fetch`, input)
            .then(res => {
                if (res.status === 200 && res.data.data.languageProducts.length > 0) {
                    let lname = res.data.data.languageProducts[0].lname;
                    let languageProducts = res.data.data.languageProducts[0].products;
                    languageProducts.forEach(element => {
                        element.qty = 1;
                        element.total = element.price;
                        element.isProductMandatory = element.isMandatory;
                    })
                    this.setState({
                        lname,
                        languageProducts
                    }, () => {
                        this.calculateSalesPrice();
                        let input1 = {};
                        input1.schoolId = this.props.school._id;
                        input1.state = this.props.school.state;
                        input1.stype = this.props.school.type;
                        input1.classId = this.props.classId;
                        axios.post(`${BASEURL}/api/v1/product/fetch`, input1)
                            .then(res => {
                                if (res.status === 200 && res.data.data.categoryProducts.length > 0) {
                                    let categoryProducts = res.data.data.categoryProducts;
                                    let books = [];
                                    let stationery = [];
                                    let uniform = [];
                                    let clothing = [];
                                    let accessories = [];
                                    categoryProducts.forEach(element => {
                                        if (element.cname === 'Books') {
                                            element.products.forEach(element1 => {
                                                element1.qty = 1;
                                                element1.total = element1.price;
                                                element1.isProductMandatory = element1.isMandatory;
                                                books.push(element1);
                                            })
                                        } else if (element.cname === 'Stationery') {
                                            element.products.forEach(element1 => {
                                                element1.qty = 1;
                                                element1.total = element1.price;
                                                element1.isProductMandatory = element1.isMandatory;
                                                stationery.push(element1);
                                            })
                                        } else if (element.cname === 'Uniform') {
                                            element.products.forEach(element1 => {
                                                element1.qty = 1;
                                                element1.total = element1.price;
                                                element1.isProductMandatory = element1.isMandatory;
                                                element1.withStitching = false;
                                                element1.selectedSize = '';
                                                element1.selectedGender = '';
                                                element1.measurementCode = '';
                                                element1.measurementData = null;
                                                element1.codeError = '';
                                                uniform.push(element1);
                                            })
                                        } else if (element.cname === 'Clothing') {
                                            element.products.forEach(element1 => {
                                                element1.qty = 1;
                                                element1.total = element1.price;
                                                element1.isProductMandatory = element1.isMandatory;
                                                clothing.push(element1);
                                            })
                                        } else if (element.cname === 'Accessories') {
                                            element.products.forEach(element1 => {
                                                element1.qty = 1;
                                                element1.total = element1.price;
                                                element1.isProductMandatory = element1.isMandatory;
                                                accessories.push(element1);
                                            })
                                        }
                                    })

                                    this.setState({
                                        books,
                                        stationery,
                                        uniform,
                                        clothing,
                                        accessories,
                                    }, () => {
                                        this.calculateSalesPrice();
                                    })
                                }
                            })
                            .catch(err => {
                                console.log('err', err)
                            })
                    })
                }
            })
            .catch(err => {
                console.log('err', err)
            })
    }

    calculateSalesPrice() {
        let salesPrice = 0;
        if (this.state.languageProducts.length === 0 && this.state.books.length === 0 && this.state.stationery.length === 0 && this.state.uniform.length === 0 && this.state.clothing.length === 0 && this.state.accessories.length === 0) {
            this.setState({
                salesPrice: 0
            })
            return;
        }
        if (this.state.languageProducts.length > 0) {
            this.state.languageProducts.forEach(element => {
                if (element.isMandatory) {
                    salesPrice = salesPrice + element.total;
                }
            })
        }
        if (this.state.books.length > 0) {
            this.state.books.forEach(element => {
                if (element.isMandatory) {
                    salesPrice = salesPrice + element.total;
                }
            })
        }
        if (this.state.stationery.length > 0) {
            this.state.stationery.forEach(element => {
                if (element.isMandatory) {
                    salesPrice = salesPrice + element.total;
                }
            })
        }
        if (this.state.uniform.length > 0) {
            this.state.uniform.forEach(element => {
                if (element.isMandatory) {
                    salesPrice = salesPrice + element.total;
                }
            })
        }
        if (this.state.clothing.length > 0) {
            this.state.clothing.forEach(element => {
                if (element.isMandatory) {
                    salesPrice = salesPrice + element.total;
                }
            })
        }
        if (this.state.accessories.length > 0) {
            this.state.accessories.forEach(element => {
                if (element.isMandatory) {
                    salesPrice = salesPrice + element.total;
                }
            })
        }
        this.setState({
            salesPrice
        })
    }

    getClothingDisplayPrice(element) {
        if (element.withStitching && element.measurementData) {
            return element.total;
        }
        return element.price;
    }

    getSizeOptionsForItem(variants) {
        if (!variants || variants.length === 0) return [];
        return [...new Set(variants.map(v => v.size))];
    }

    getGenderOptionsForItem(variants, selectedSize) {
        if (!variants || !selectedSize) return [];
        return variants.filter(v => v.size === selectedSize).map(v => v.gender);
    }

    handleUpdateLanguageQuantity(idx, action) {
        let languageProducts = this.state.languageProducts;
        languageProducts = languageProducts.map((item, index) => {
            if (index === idx && item.isMandatory) {
                if (action === 'sub' && item.qty !== 1) {
                    item.qty = item.qty - 1;
                    item.total = item.total - item.price;
                }
                if (action === 'add') {
                    item.qty = item.qty + 1;
                    item.total = item.total + item.price;
                }
            }
            return item;
        })
        this.setState({
            languageProducts
        }, () => {
            this.calculateSalesPrice();
        })
    }

    handleUpdateBooksQuantity(idx, action) {
        let books = this.state.books;
        books = books.map((item, index) => {
            if (index === idx && item.isMandatory) {
                if (action === 'sub' && item.qty !== 1) {
                    item.qty = item.qty - 1;
                    item.total = item.total - item.price;
                }
                if (action === 'add') {
                    item.qty = item.qty + 1;
                    item.total = item.total + item.price;
                }
            }
            return item;
        })
        this.setState({
            books
        }, () => {
            this.calculateSalesPrice();
        })
    }

    handleUpdateClothingQuantity(idx, action) {
        let clothing = this.state.clothing;
        clothing = clothing.map((item, index) => {
            if (index === idx && item.isMandatory) {
                if (action === 'sub' && item.qty !== 1) {
                    item.qty = item.qty - 1;
                    item.total = item.total - item.price;
                }
                if (action === 'add') {
                    item.qty = item.qty + 1;
                    item.total = item.total + item.price;
                }
            }
            return item;
        })
        this.setState({
            clothing
        }, () => {
            this.calculateSalesPrice();
        })
    }

    handleUpdateAccessoriesQuantity(idx, action) {
        let accessories = this.state.accessories;
        accessories = accessories.map((item, index) => {
            if (index === idx && item.isMandatory) {
                if (action === 'sub' && item.qty !== 1) {
                    item.qty = item.qty - 1;
                    item.total = item.total - item.price;
                }
                if (action === 'add') {
                    item.qty = item.qty + 1;
                    item.total = item.total + item.price;
                }
            }
            return item;
        })
        this.setState({
            accessories
        }, () => {
            this.calculateSalesPrice();
        })
    }

    handleChangeStationeryMandatory(e, idx) {
        let stationery = [...this.state.stationery];
        stationery[idx]['isMandatory'] = e.target.checked;

        let salesPrice = this.state.salesPrice;
        if (e.target.checked) {
            salesPrice = salesPrice + stationery[idx]['total'];
        } else {
            salesPrice = salesPrice - stationery[idx]['total'];
            stationery[idx]['qty'] = 1;
            stationery[idx]['total'] = stationery[idx]['price'];
        }

        this.setState({
            stationery,
            salesPrice
        });
    }

    handleUpdateStationeryQuantity(idx, action) {
        let stationery = [...this.state.stationery];
        stationery = stationery.map((item, index) => {
            if (index === idx && item.isMandatory) {
                if (action === 'sub' && item.qty !== 1) {
                    item.qty = item.qty - 1;
                    item.total = item.total - item.price;
                }
                if (action === 'add') {
                    item.qty = item.qty + 1;
                    item.total = item.total + item.price;
                }
            }
            return item;
        });

        this.setState({
            stationery
        }, () => {
            this.calculateSalesPrice();
        });
    }

    handleChangeLangMandatory(e, idx) {
        let languageProducts = this.state.languageProducts;
        languageProducts[idx]['isMandatory'] = e.target.checked;

        let salesPrice = this.state.salesPrice;
        if (e.target.checked) {
            salesPrice = salesPrice + languageProducts[idx]['total'];
        } else {
            languageProducts[idx]['qty'] = 1;
            salesPrice = salesPrice - languageProducts[idx]['total'];
            languageProducts[idx]['total'] = languageProducts[idx]['price']
        }

        this.setState({
            languageProducts,
            salesPrice
        })
    }

    handleChangeProductData(e, idx) {
        let books = this.state.books;
        books[idx]['isMandatory'] = e.target.checked;

        let salesPrice = this.state.salesPrice;
        if (e.target.checked) {
            salesPrice = salesPrice + books[idx]['total'];
        } else {
            books[idx]['qty'] = 1;
            salesPrice = salesPrice - books[idx]['total'];
            books[idx]['total'] = books[idx]['price']
        }
        this.setState({
            books,
            salesPrice
        })
    }

    handleChangeClothingMandatory(e, idx) {
        let clothing = [...this.state.clothing];
        clothing[idx]['isMandatory'] = e.target.checked;

        let salesPrice = this.state.salesPrice;
        if (e.target.checked) {
            salesPrice = salesPrice + clothing[idx]['total'];
        } else {
            clothing[idx]['qty'] = 1;
            salesPrice = salesPrice - clothing[idx]['total'];
            clothing[idx]['total'] = clothing[idx]['price'];
        }
        this.setState({ clothing, salesPrice });
    }

    handleChangeUniformMandatory(e, idx) {
        let uniform = [...this.state.uniform];
        uniform[idx]['isMandatory'] = e.target.checked;

        let salesPrice = this.state.salesPrice;
        if (e.target.checked) {
            salesPrice = salesPrice + uniform[idx]['total'];
        } else {
            salesPrice = salesPrice - uniform[idx]['total'];
        }
        this.setState({ uniform, salesPrice });
    }

    handleUniformStitchingToggle(idx, withStitching) {
        let uniform = [...this.state.uniform];
        const item = uniform[idx];
        const wasMandatory = item.isMandatory;
        const oldTotal = item.total;

        item.withStitching = withStitching;
        item.selectedSize = '';
        item.selectedGender = '';
        item.measurementCode = '';
        item.measurementData = null;
        item.stitchingConfirmed = false;
        item.codeError = '';
        item.total = item.price;

        let salesPrice = this.state.salesPrice;
        if (wasMandatory) {
            salesPrice = salesPrice - oldTotal + item.total;
        }

        this.setState({ uniform, salesPrice });
    }

    handleUniformMeasurementCode(idx, value) {
        let uniform = [...this.state.uniform];
        uniform[idx].measurementCode = value;
        uniform[idx].codeError = '';
        this.setState({ uniform });
    }

    handleViewMeasurementDetails(idx) {
        const code = this.state.uniform[idx].measurementCode.trim();
        if (!code) return;
        this.setState({
            measurementModal: { show: true, productIdx: idx, loading: true, data: null, error: null }
        });
        axios.get(`${BASEURL}/api/v1/studentMeasurements/fetchByCode/${code}`)
            .then(res => {
                this.setState({
                    measurementModal: { show: true, productIdx: idx, loading: false, data: res.data, error: null }
                });
            })
            .catch(err => {
                const msg = err.response && err.response.status === 404
                    ? 'Invalid measurement code. No record found.'
                    : 'Something went wrong. Please try again.';
                this.setState({
                    measurementModal: { show: true, productIdx: idx, loading: false, data: null, error: msg }
                });
            });
    }

    handleConfirmMeasurement() {
        const { productIdx, data } = this.state.measurementModal;
        if (!data) return;
        let uniform = [...this.state.uniform];
        const item = uniform[productIdx];
        const oldTotal = item.total;

        const variants = item.variants || [];
        const variant = variants.find(v => v.size === data.size && v.gender === data.gender);

        const newTotal = variant ? variant.price : item.total;

        uniform[productIdx] = {
            ...item,
            selectedSize: data.size,
            selectedGender: data.gender,
            measurementData: data,
            stitchingConfirmed: true,
            total: newTotal,
        };

        let salesPrice = this.state.salesPrice;
        if (item.isMandatory) {
            salesPrice = salesPrice - oldTotal + newTotal;
        }

        this.setState({
            uniform,
            salesPrice,
            measurementModal: { show: false, productIdx: null, loading: false, data: null, error: null }
        });
    }

    handleCloseMeasurementModal() {
        this.setState({
            measurementModal: { show: false, productIdx: null, loading: false, data: null, error: null }
        });
    }

    handleResetMeasurement(idx) {
        let uniform = [...this.state.uniform];
        const item = uniform[idx];
        const oldTotal = item.total;

        item.measurementCode = '';
        item.codeError = '';
        item.selectedSize = '';
        item.selectedGender = '';
        item.measurementData = null;
        item.stitchingConfirmed = false;
        item.total = item.price;

        let salesPrice = this.state.salesPrice;
        if (item.isMandatory) {
            salesPrice = salesPrice - oldTotal + item.total;
        }
        this.setState({ uniform, salesPrice });
    }

    handleChangeAccessoriesMandatory(e, idx) {
        let accessories = this.state.accessories;
        accessories[idx]['isMandatory'] = e.target.checked;

        let salesPrice = this.state.salesPrice;
        if (e.target.checked) {
            salesPrice = salesPrice + accessories[idx]['total'];
        } else {
            accessories[idx]['qty'] = 1;
            salesPrice = salesPrice - accessories[idx]['total'];
            accessories[idx]['total'] = accessories[idx]['price']
        }
        this.setState({
            accessories,
            salesPrice
        })
    }

    handleAddToCart() {
        const { salesPrice, productSetName, productSetId } = this.state;
        if (salesPrice === 0) {
            swal('Warning', 'Please select atleast one product to add to cart.', 'warning');
            return;
        }
        if (this.props.cartProducts && this.props.cartProducts.length > 0) {
            swal('Warning', 'Only one product set can be added to the cart at a time. Please remove the existing item before adding a new one.', 'warning');
            return;
        }
        const unconfirmedUniform = this.state.uniform.filter(item => item.isMandatory && item.withStitching && !item.stitchingConfirmed);
        if (unconfirmedUniform.length > 0) {
            const names = unconfirmedUniform.map(item => item.pname).join(', ');
            swal('Warning', `Please click on view measurement details and confirm for the following uniform item(s) before adding to cart: ${names}`, 'warning');
            return;
        }
        let categoryNames = [];
        if (this.state.books.length > 0) {
            categoryNames.push('Books')
        }
        if (this.state.stationery.length > 0) {
            categoryNames.push('Stationery')
        }
        if (this.state.uniform.length > 0) {
            categoryNames.push('Uniform')
        }
        if (this.state.clothing.length > 0) {
            categoryNames.push('Clothing')
        }
        if (this.state.accessories.length > 0) {
            categoryNames.push('Accessories')
        }
        let cartItem = {
            productSetName,
            productSetId,
            price: salesPrice,
            categoryNames,
            categories: {
                languageProducts: this.state.languageProducts.filter(function (item) { return item.isMandatory; }).map(function (item) { return item; }),
                books: this.state.books.filter(function (item) { return item.isMandatory; }).map(function (item) { return item; }),
                stationery: this.state.stationery.filter(function (item) { return item.isMandatory; }).map(function (item) { return item; }),
                uniform: this.state.uniform.filter(function (item) { return item.isMandatory; }).map(function (item) { return item; }),
                clothing: this.state.clothing.filter(function (item) { return item.isMandatory; }).map(function (item) { return item; }),
                accessories: this.state.accessories.filter(function (item) { return item.isMandatory; }).map(function (item) { return item; }),
            },
            languageId: this.props.langId,
            classId: this.props.classId,
            languageName: this.props.lname,
            className: this.props.className,
        }
        this.props.addProductsToCart(cartItem);
        this.props.history.push('cart');
    }

    render() {
        return (
            <div className="site-wrap">
                <Header page={'shop'} />
                <div className="site-section">
                    <div className="container">
                        <div className='d-flex'>
                            <a href={`school/${this.props.school.name}`} className='text-black mr-3'><span className='icon icon-angle-left mr-1'></span></a>
                            <h5 className='text-primary'>{this.state.productSetName}</h5>
                        </div>
                        <div className="row mb-5 p-3">
                            {this.state.languageProducts.length > 0 ?
                                <>
                                    <h6 className='text-black mb-2'>Language: <sapn className="text-primary">{this.state.lname}</sapn></h6>
                                    <div className='table-responsive mt-3 mb-3'>
                                        <table className='table table-bordered'>
                                            <colgroup>
                                                <col style={{ width: '70%' }} />
                                                <col style={{ width: '130px' }} />
                                            </colgroup>
                                            <thead className='thead thead-dark'>
                                                <tr>
                                                    <th>Product Name</th>
                                                    {/* <th>Qty</th> */}
                                                    <th>Price (Rs.)</th>
                                                    {/* <th>Total Price</th> */}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.languageProducts.map((element, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            {element.isProductMandatory ?
                                                                <td>
                                                                    <div className="custom-control custom-checkbox">
                                                                        <input type="checkbox" className="custom-control-input" id={`langMandatory${index}`} name="isMandatory"
                                                                            defaultChecked={element.isProductMandatory} disabled={element.isMandatory} />
                                                                        <label className="custom-control-label" htmlFor={`langMandatory${index}`}>{element.pname}</label>
                                                                    </div>
                                                                </td>
                                                                :
                                                                <td>
                                                                    <div className="custom-control custom-checkbox">
                                                                        <input type="checkbox" className="custom-control-input" id={`langMandatory${index}`} name="isMandatory"
                                                                            onChange={(e) => this.handleChangeLangMandatory(e, index)}
                                                                            defaultChecked={element.isProductMandatory} />
                                                                        <label className="custom-control-label" htmlFor={`langMandatory${index}`}>{element.pname}</label>
                                                                    </div>
                                                                </td>
                                                            }
                                                            {/* <td>
                                                                <div className="input-group mb-3" style={{ maxWidth: '120px' }}>
                                                                    <div className="input-group-prepend">
                                                                        <button className="btn btn-outline-primary" type="button" onClick={() => this.handleUpdateLanguageQuantity(index, 'sub')}>−</button>
                                                                    </div>
                                                                    <p className="form-control text-center">{element.qty}</p>
                                                                    <div className="input-group-append">
                                                                        <button className="btn btn-outline-primary" type="button" onClick={() => this.handleUpdateLanguageQuantity(index, 'add')}>+</button>
                                                                    </div>
                                                                </div>
                                                            </td> */}
                                                            <td style={{ whiteSpace: 'nowrap' }}>₹{element.price}</td>
                                                            {/* <td>₹{element.total}</td> */}
                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </table>
                                    </div>

                                </>
                                : ''}
                            {this.state.books.length > 0 ?
                                <>
                                    <h6 className='text-black mb-2'>Product Type: <sapn className="text-primary">Books</sapn></h6>
                                    <div className='table-responsive mt-3 mb-3'>
                                        <table className='table table-bordered'>
                                            <colgroup>
                                                <col style={{ width: '70%' }} />
                                                <col style={{ width: '130px' }} />
                                            </colgroup>
                                            <thead className='thead thead-dark'>
                                                <tr>
                                                    <th>Product Name</th>
                                                    {/* <th>Qty</th> */}
                                                    <th>Price (Rs.)</th>
                                                    {/* <th>Total Price</th> */}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.books.map((element, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            {element.isProductMandatory ?
                                                                <td>
                                                                    <div className="custom-control custom-checkbox">
                                                                        <input type="checkbox" className="custom-control-input" id={`booksMandatory${index}`} name="isMandatory"
                                                                            defaultChecked={element.isProductMandatory} disabled />
                                                                        <label className="custom-control-label" htmlFor={`booksMandatory${index}`}>{element.pname}</label>
                                                                    </div>
                                                                </td>
                                                                :
                                                                <td>
                                                                    <div className="custom-control custom-checkbox">
                                                                        <input type="checkbox" className="custom-control-input" id={`booksMandatoryDisabled${index}`} name="isMandatory"
                                                                            onChange={(e) => this.handleChangeProductData(e, index)}
                                                                            defaultChecked={element.isProductMandatory} />
                                                                        <label className="custom-control-label" htmlFor={`booksMandatoryDisabled${index}`}>{element.pname}</label>
                                                                    </div>
                                                                </td>
                                                            }
                                                            {/* <td>
                                                                <div className="input-group mb-3" style={{ maxWidth: '120px' }}>
                                                                    <div className="input-group-prepend">
                                                                        <button className="btn btn-outline-primary" type="button" onClick={() => this.handleUpdateBooksQuantity(index, 'sub')}>−</button>
                                                                    </div>
                                                                    <p className="form-control text-center">{element.qty}</p>
                                                                    <div className="input-group-append">
                                                                        <button className="btn btn-outline-primary" type="button" onClick={() => this.handleUpdateBooksQuantity(index, 'add')}>+</button>
                                                                    </div>
                                                                </div>
                                                            </td> */}
                                                            <td style={{ whiteSpace: 'nowrap' }}>₹{element.price}</td>
                                                            {/* <td>₹{element.total}</td> */}
                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </table>
                                    </div>

                                </>
                                : ''}
                            {this.state.stationery.length > 0 ?
                                <>
                                    <h6 className='text-black mb-2'>Product Type: <sapn className="text-primary">Stationery</sapn></h6>
                                    <div className='table-responsive mt-3 mb-3'>
                                        <table className='table table-bordered'>
                                            <colgroup>
                                                <col style={{ width: '70%' }} />
                                                <col style={{ width: '130px' }} />
                                            </colgroup>
                                            <thead className='thead thead-dark'>
                                                <tr>
                                                    <th>Product Name</th>
                                                    {/* <th>Qty</th> */}
                                                    <th>Price (Rs.)</th>
                                                    {/* <th>Total Price</th> */}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.stationery.map((element, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            {element.isProductMandatory ?
                                                                <td>
                                                                    <div className="custom-control custom-checkbox">
                                                                        <input type="checkbox" className="custom-control-input" id={`stationeryMandatory${index}`} name="isMandatory"
                                                                            defaultChecked={element.isProductMandatory} disabled />
                                                                        <label className="custom-control-label" htmlFor={`stationeryMandatory${index}`}>{element.pname}</label>
                                                                    </div>
                                                                </td>
                                                                :
                                                                <td>
                                                                    <div className="custom-control custom-checkbox">
                                                                        <input type="checkbox" className="custom-control-input" id={`stationeryMandatoryDisabled${index}`} name="isMandatory"
                                                                            onChange={(e) => this.handleChangeStationeryMandatory(e, index)} defaultChecked={element.isProductMandatory} />
                                                                        <label className="custom-control-label" htmlFor={`stationeryMandatoryDisabled${index}`}>{element.pname}</label>
                                                                    </div>
                                                                </td>
                                                            }
                                                            {/* <td>
                                                                <div className="input-group mb-3" style={{ maxWidth: '120px' }}>
                                                                    <div className="input-group-prepend">
                                                                        <button className="btn btn-outline-primary" type="button" onClick={() => this.handleUpdateStationeryQuantity(index, 'sub')}>−</button>
                                                                    </div>
                                                                    <p className="form-control text-center">{element.qty}</p>
                                                                    <div className="input-group-append">
                                                                        <button className="btn btn-outline-primary" type="button" onClick={() => this.handleUpdateStationeryQuantity(index, 'add')}>+</button>
                                                                    </div>
                                                                </div>
                                                            </td> */}
                                                            <td style={{ whiteSpace: 'nowrap' }}>₹{element.price}</td>
                                                            {/* <td>₹{element.total}</td> */}
                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </table>
                                    </div>

                                </>
                                : ''}
                            {this.state.uniform.length > 0 ?
                                <>
                                    <h6 className='text-black mb-2'>Product Type: <sapn className="text-primary">Uniform</sapn></h6>
                                    <div className='table-responsive mt-3 mb-3'>
                                        <table className='table table-bordered'>
                                            <colgroup>
                                                <col style={{ width: '35%' }} />
                                                <col style={{ width: '130px' }} />
                                                <col />
                                            </colgroup>
                                            <thead className='thead thead-dark'>
                                                <tr>
                                                    <th>Product Name</th>
                                                    <th>Price (Rs.)</th>
                                                    <th>Stitching</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.uniform.map((element, index) => {
                                                    const hasVariants = element.variants && element.variants.length > 0;
                                                    const displayPrice = this.getClothingDisplayPrice(element);
                                                    return (
                                                        <tr key={index}>
                                                            <td>
                                                                {element.isProductMandatory ?
                                                                    <div className="custom-control custom-checkbox">
                                                                        <input type="checkbox" className="custom-control-input" id={`uniformMandatory${index}`}
                                                                            defaultChecked={element.isMandatory} disabled />
                                                                        <label className="custom-control-label" htmlFor={`uniformMandatory${index}`}>{element.pname}</label>
                                                                    </div>
                                                                    :
                                                                    <div className="custom-control custom-checkbox">
                                                                        <input type="checkbox" className="custom-control-input" id={`uniformMandatoryDisabled${index}`}
                                                                            onChange={(e) => this.handleChangeUniformMandatory(e, index)}
                                                                            defaultChecked={element.isProductMandatory} />
                                                                        <label className="custom-control-label" htmlFor={`uniformMandatoryDisabled${index}`}>{element.pname}</label>
                                                                    </div>
                                                                }
                                                            </td>
                                                            <td style={{ whiteSpace: 'nowrap' }}>₹{displayPrice}</td>
                                                            <td>
                                                                {hasVariants ? (
                                                                    <>
                                                                        <div className="btn-group btn-group-sm" role="group">
                                                                            <button
                                                                                type="button"
                                                                                className={`btn ${!element.withStitching ? 'btn-primary' : 'btn-outline-secondary'}`}
                                                                                onClick={() => this.handleUniformStitchingToggle(index, false)}
                                                                            >
                                                                                Without Stitching
                                                                            </button>
                                                                            <button
                                                                                type="button"
                                                                                className={`btn ${element.withStitching ? 'btn-primary' : 'btn-outline-secondary'}`}
                                                                                onClick={() => this.handleUniformStitchingToggle(index, true)}
                                                                            >
                                                                                With Stitching
                                                                            </button>
                                                                        </div>
                                                                        {element.withStitching && (
                                                                            <div className="mt-2">
                                                                                {element.measurementData ? (
                                                                                    <div className="d-flex align-items-center" style={{ gap: '8px' }}>
                                                                                        <span className="badge badge-success" style={{ fontSize: '0.8rem', padding: '5px 8px' }}>
                                                                                            Size: {element.measurementData.size} &nbsp;|&nbsp; Gender: {element.measurementData.gender}
                                                                                        </span>
                                                                                        <a
                                                                                            href="#!"
                                                                                            className="small text-danger"
                                                                                            style={{ textDecoration: 'underline', cursor: 'pointer' }}
                                                                                            onClick={(e) => { e.preventDefault(); this.handleResetMeasurement(index); }}
                                                                                        >
                                                                                            Change
                                                                                        </a>
                                                                                    </div>
                                                                                ) : (
                                                                                    <>
                                                                                        <div>
                                                                                            <input
                                                                                                type="text"
                                                                                                className="form-control form-control-sm"
                                                                                                style={{ width: '100%' }}
                                                                                                placeholder="Enter measurement code"
                                                                                                value={element.measurementCode}
                                                                                                onChange={(e) => this.handleUniformMeasurementCode(index, e.target.value)}
                                                                                            />
                                                                                            {element.measurementCode.trim() && (
                                                                                                <a
                                                                                                    href="#!"
                                                                                                    className="small text-primary"
                                                                                                    style={{ textDecoration: 'underline', cursor: 'pointer' }}
                                                                                                    onClick={(e) => { e.preventDefault(); this.handleViewMeasurementDetails(index); }}
                                                                                                >
                                                                                                    View Measurement Details
                                                                                                </a>
                                                                                            )}
                                                                                        </div>
                                                                                        {element.codeError && (
                                                                                            <small className="text-danger">{element.codeError}</small>
                                                                                        )}
                                                                                    </>
                                                                                )}
                                                                            </div>
                                                                        )}
                                                                    </>
                                                                ) : (
                                                                    <span className="text-muted">—</span>
                                                                )}
                                                            </td>
                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </table>
                                    </div>

                                </>
                                : ''}
                            {this.state.clothing.length > 0 ?
                                <>
                                    <h6 className='text-black mb-2'>Product Type: <sapn className="text-primary">Clothing</sapn></h6>
                                    <div className='table-responsive mt-3 mb-3'>
                                        <table className='table table-bordered'>
                                            <colgroup>
                                                <col style={{ width: '70%' }} />
                                                <col style={{ width: '130px' }} />
                                            </colgroup>
                                            <thead className='thead thead-dark'>
                                                <tr>
                                                    <th>Product Name</th>
                                                    <th>Price (Rs.)</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.clothing.map((element, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            {element.isProductMandatory ?
                                                                <td>
                                                                    <div className="custom-control custom-checkbox">
                                                                        <input type="checkbox" className="custom-control-input" id={`clothingMandatory${index}`}
                                                                            defaultChecked={element.isMandatory} disabled />
                                                                        <label className="custom-control-label" htmlFor={`clothingMandatory${index}`}>{element.pname}</label>
                                                                    </div>
                                                                </td>
                                                                :
                                                                <td>
                                                                    <div className="custom-control custom-checkbox">
                                                                        <input type="checkbox" className="custom-control-input" id={`clothingMandatoryDisabled${index}`}
                                                                            onChange={(e) => this.handleChangeClothingMandatory(e, index)}
                                                                            defaultChecked={element.isProductMandatory} />
                                                                        <label className="custom-control-label" htmlFor={`clothingMandatoryDisabled${index}`}>{element.pname}</label>
                                                                    </div>
                                                                </td>
                                                            }
                                                            <td style={{ whiteSpace: 'nowrap' }}>₹{element.price}</td>
                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </table>
                                    </div>

                                </>
                                : ''}
                            {this.state.accessories.length > 0 ?
                                <>
                                    <h6 className='text-black mb-2'>Product Type: <sapn className="text-primary">Accessories</sapn></h6>
                                    <div className='table-responsive mt-3 mb-3'>
                                        <table className='table table-bordered'>
                                            <colgroup>
                                                <col style={{ width: '70%' }} />
                                                <col style={{ width: '130px' }} />
                                            </colgroup>
                                            <thead className='thead thead-dark'>
                                                <tr>
                                                    <th>Product Name</th>
                                                    {/* <th>Qty</th> */}
                                                    <th>Price (Rs.)</th>
                                                    {/* <th>Total Price</th> */}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.accessories.map((element, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            {element.isProductMandatory ?
                                                                <td>
                                                                    <div className="custom-control custom-checkbox">
                                                                        <input type="checkbox" className="custom-control-input" id={`accessoriesMandatory${index}`}
                                                                            defaultChecked={element.isMandatory} disabled />
                                                                        <label className="custom-control-label" htmlFor={`accessoriesMandatory${index}`}>{element.pname}</label>
                                                                    </div>
                                                                </td>
                                                                :
                                                                <td>
                                                                    <div className="custom-control custom-checkbox">
                                                                        <input type="checkbox" className="custom-control-input" id={`accessoriesMandatoryDisabled${index}`}
                                                                            onChange={(e) => this.handleChangeAccessoriesMandatory(e, index)}
                                                                            defaultChecked={element.isProductMandatory} />
                                                                        <label className="custom-control-label" htmlFor={`accessoriesMandatoryDisabled${index}`}>{element.pname}</label>
                                                                    </div>
                                                                </td>
                                                            }
                                                            {/* <td>
                                                                <div className="input-group mb-3" style={{ maxWidth: '120px' }}>
                                                                    <div className="input-group-prepend">
                                                                        <button className="btn btn-outline-primary" type="button" onClick={() => this.handleUpdateAccessoriesQuantity(index, 'sub')}>−</button>
                                                                    </div>
                                                                    <p className="form-control text-center">{element.qty}</p>
                                                                    <div className="input-group-append">
                                                                        <button className="btn btn-outline-primary" type="button" onClick={() => this.handleUpdateAccessoriesQuantity(index, 'add')}>+</button>
                                                                    </div>
                                                                </div>
                                                            </td> */}
                                                            <td style={{ whiteSpace: 'nowrap' }}>₹{element.price}</td>
                                                            {/* <td>₹{element.total}</td> */}
                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </table>
                                    </div>

                                </>
                                : ''}
                            <div className='ml-auto'>
                                <h6 className='text-black mb-2'>Sales Price: <sapn className="text-primary">₹{this.state.salesPrice}</sapn></h6>
                            </div>
                        </div>
                        <div className='cartBtnsDiv'>
                            <button className='btn btn-primary' onClick={() => this.handleAddToCart()}>Add to Cart</button>
                        </div>
                    </div>
                </div>
                <Footer />

                {/* Measurement Details Modal */}
                {this.state.measurementModal.show && (
                    <>
                        <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog">
                            <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title">Measurement Details</h5>
                                        <button type="button" className="close" onClick={() => this.handleCloseMeasurementModal()}>
                                            <span>&times;</span>
                                        </button>
                                    </div>
                                    <div className="modal-body">
                                        {this.state.measurementModal.loading && (
                                            <p className="text-center text-muted">Fetching measurement details...</p>
                                        )}
                                        {this.state.measurementModal.error && (
                                            <div className="alert alert-info">{this.state.measurementModal.error}</div>
                                        )}
                                        {this.state.measurementModal.data && (() => {
                                            const d = this.state.measurementModal.data;
                                            const measurementFields = [
                                                { name: 'chestBust', label: 'Chest / Bust (inches)' },
                                                { name: 'waist', label: 'Waist (inches)' },
                                                { name: 'hip', label: 'Hip (inches)' },
                                                { name: 'shoulderWidth', label: 'Shoulder Width (inches)' },
                                                { name: 'neck', label: 'Neck (inches)' },
                                                { name: 'ankle', label: 'Ankle (inches)' },
                                                { name: 'sleeveLength', label: 'Sleeve Length (inches)' },
                                                { name: 'upperArmBicep', label: 'Upper Arm / Bicep (inches)' },
                                                { name: 'wrist', label: 'Wrist (inches)' },
                                                { name: 'armholeScye', label: 'Armhole / Scye (inches)' },
                                                { name: 'frontLength', label: 'Front Length (inches)' },
                                                { name: 'fullBodyLength', label: 'Full Body Length (inches)' },
                                                { name: 'inseam', label: 'Inseam (inches)' },
                                                { name: 'outseamSideLength', label: 'Outseam / Side Length (inches)' },
                                                { name: 'thigh', label: 'Thigh (inches)' },
                                                { name: 'knee', label: 'Knee (inches)' },
                                            ];
                                            const filledFields = measurementFields.filter(f => d.measurements && d.measurements[f.name] != null && d.measurements[f.name] !== '');
                                            return (
                                                <>
                                                    <div className="row mb-3">
                                                        <div className="col-sm-6">
                                                            <strong>Gender</strong>
                                                            <p className="text-muted mb-0">{d.gender || '—'}</p>
                                                        </div>
                                                        <div className="col-sm-6">
                                                            <strong>Size</strong>
                                                            <p className="text-muted mb-0">{d.size || '—'}</p>
                                                        </div>
                                                    </div>
                                                    {filledFields.length > 0 && (
                                                        <>
                                                            <hr />
                                                            <div className="row">
                                                                {filledFields.map(f => (
                                                                    <div className="col-sm-4 mb-2" key={f.name}>
                                                                        <small className="text-muted d-block">{f.label}</small>
                                                                        <strong>{d.measurements[f.name]}</strong>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </>
                                                    )}
                                                </>
                                            );
                                        })()}
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-outline-secondary" onClick={() => this.handleCloseMeasurementModal()}>
                                            Cancel
                                        </button>
                                        {this.state.measurementModal.data && (
                                            <button type="button" className="btn btn-primary" onClick={() => this.handleConfirmMeasurement()}>
                                                Confirm
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-backdrop fade show"></div>
                    </>
                )}
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        school: getSchool(state),
        className: getClassName(state),
        lname: getLanguageName(state),
        classId: getClassId(state),
        langId: getLanguageId(state),
        cartProducts: getCartProducts(state),
    }
}

const mapDispatchToProps = dispatch => ({
    addProductsToCart: (products) => dispatch(addProductsToCart(products)),
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(schoolProducts);
